// Idempotent write ids: an identical retry reuses its request id (so a lost response is never
// applied twice); any change to the input mints a new one.
export interface RetryAttempt {
  fingerprint: string;
  requestId: string;
}

export function requestIdFor(
  body: Record<string, unknown>,
  previous: RetryAttempt | null,
  mint: () => string = () => crypto.randomUUID()
): RetryAttempt {
  const fingerprint = JSON.stringify(body);
  return previous?.fingerprint === fingerprint
    ? previous
    : { fingerprint, requestId: mint() };
}
